(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var AUTOPLAY_MS = 5000;
  var RESUME_DELAY_MS = 1500;

  function isCarouselMode() {
    return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initSection(section) {
    if (!section || section.dataset.pressReviewInit === 'true') return;
    section.dataset.pressReviewInit = 'true';

    var logosEl = section.querySelector('.oddit-section-press-review__logos');
    var buttons = section.querySelectorAll('.oddit-section-press-review__logo-button');
    var quotes = section.querySelectorAll('.oddit-section-press-review__quote');
    if (!logosEl || !buttons.length || !quotes.length) return;

    var suppressObserver = false;
    var suppressTimer = null;
    var autoplayTimer = null;
    var resumeTimer = null;
    var autoplayPaused = false;
    var autoplayDisabled = prefersReducedMotion();

    function setActive(button) {
      var press = button.getAttribute('data-press');
      if (!press) return;

      for (var i = 0; i < buttons.length; i++) {
        var b = buttons[i];
        var isActive = b === button;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        b.setAttribute('tabindex', isActive ? '0' : '-1');
      }

      for (var j = 0; j < quotes.length; j++) {
        var q = quotes[j];
        var isMatch = q.getAttribute('data-press') === press;
        q.classList.toggle('is-active', isMatch);
        q.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
      }
    }

    function scrollIntoCenter(button) {
      // Scroll the logos rail only — never the page. Using button.scrollIntoView
      // walks up every scrollable ancestor (incl. the document), so during
      // autoplay it would yank the viewport back to this section once the user
      // had scrolled past it.
      if (!logosEl) return;
      var target = button.offsetLeft - (logosEl.clientWidth - button.offsetWidth) / 2;
      var max = logosEl.scrollWidth - logosEl.clientWidth;
      if (target < 0) target = 0;
      else if (target > max) target = max;
      try {
        logosEl.scrollTo({ left: target, behavior: 'smooth' });
      } catch (e) {
        logosEl.scrollLeft = target;
      }
    }

    function suppressObserverBriefly() {
      suppressObserver = true;
      if (suppressTimer) clearTimeout(suppressTimer);
      suppressTimer = setTimeout(function () {
        suppressObserver = false;
      }, 600);
    }

    function activate(button, opts) {
      opts = opts || {};
      setActive(button);
      if (opts.scroll && isCarouselMode()) {
        suppressObserverBriefly();
        scrollIntoCenter(button);
      }
    }

    function currentIndex() {
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function advanceNext() {
      var nextIdx = (currentIndex() + 1) % buttons.length;
      activate(buttons[nextIdx], { scroll: true });
    }

    function clearAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function clearResume() {
      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function startAutoplay() {
      if (autoplayDisabled || autoplayPaused) return;
      clearAutoplay();
      autoplayTimer = setInterval(advanceNext, AUTOPLAY_MS);
    }

    function pauseAutoplay() {
      autoplayPaused = true;
      clearAutoplay();
      clearResume();
    }

    function resumeAutoplay() {
      autoplayPaused = false;
      startAutoplay();
    }

    function deferredResume() {
      clearResume();
      resumeTimer = setTimeout(function () {
        autoplayPaused = false;
        startAutoplay();
      }, RESUME_DELAY_MS);
    }

    function handleClick(e) {
      activate(e.currentTarget, { scroll: true });
      // Reset the autoplay countdown so user gets full dwell on their pick.
      if (!autoplayPaused) startAutoplay();
    }

    function handleKeydown(e) {
      var key = e.key;
      var current = -1;
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i] === e.currentTarget) { current = i; break; }
      }
      if (current < 0) return;

      var next = -1;
      if (key === 'ArrowRight') next = (current + 1) % buttons.length;
      else if (key === 'ArrowLeft') next = (current - 1 + buttons.length) % buttons.length;
      else if (key === 'Home') next = 0;
      else if (key === 'End') next = buttons.length - 1;

      if (next >= 0) {
        e.preventDefault();
        activate(buttons[next], { scroll: true });
        buttons[next].focus();
      }
    }

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', handleClick);
      buttons[i].addEventListener('keydown', handleKeydown);
    }

    // Carousel sync: when a logo lands in the center on mobile, activate it.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (suppressObserver || !isCarouselMode()) return;
        var bestEntry = null;
        for (var k = 0; k < entries.length; k++) {
          var entry = entries[k];
          if (!entry.isIntersecting) continue;
          if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
            bestEntry = entry;
          }
        }
        if (bestEntry && bestEntry.intersectionRatio > 0.5) {
          setActive(bestEntry.target);
        }
      }, {
        root: logosEl,
        rootMargin: '0px -45% 0px -45%',
        threshold: [0, 0.5, 1]
      });

      for (var m = 0; m < buttons.length; m++) {
        observer.observe(buttons[m]);
      }
    }

    // Pause autoplay on pointer/focus/touch interaction.
    section.addEventListener('mouseenter', pauseAutoplay);
    section.addEventListener('mouseleave', resumeAutoplay);
    section.addEventListener('focusin', pauseAutoplay);
    section.addEventListener('focusout', resumeAutoplay);

    logosEl.addEventListener('touchstart', pauseAutoplay, { passive: true });
    logosEl.addEventListener('touchend', deferredResume, { passive: true });
    logosEl.addEventListener('touchcancel', deferredResume, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pauseAutoplay();
      else resumeAutoplay();
    });

    // React to a runtime change in the reduced-motion preference.
    if (window.matchMedia) {
      var rmQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var onRmChange = function () {
        autoplayDisabled = rmQuery.matches;
        if (autoplayDisabled) clearAutoplay();
        else startAutoplay();
      };
      if (rmQuery.addEventListener) rmQuery.addEventListener('change', onRmChange);
      else if (rmQuery.addListener) rmQuery.addListener(onRmChange);
    }

    startAutoplay();
  }

  var sections = document.querySelectorAll('.oddit-section-press-review');
  for (var i = 0; i < sections.length; i++) initSection(sections[i]);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.oddit-section-press-review');
    if (section) initSection(section);
  });
})();
